module.exports = __webpack_public_path__ + "img/drop.ebfe4f5d.png";